import Vue from "vue";

class SupportService {

    async getTermsAndConditions(){
        try {
            return await Vue.axios.get("/knowledge-base/post/ecom-quy-dinh-chinh-sach");
        } catch(e) {
            return Promise.reject(e)
        }
    }

    /**
     * @description Only get term and condition in hyperlead, it not require user login to view it
     * @returns 
     */
    async getTermsAndConditionsSignup() {
        try {
            return await Vue.axios.get("/sign-up/terms-and-conditions");
        } catch(e) {
            return Promise.reject(e);
        }
    }
    
    /**
     * @description Get the knowledge post info with slug parameter 
     * @param {String} slug 
     * @returns 
     */
    async knowledgeBaseInfo(slug = ""){
        try {
            return await Vue.axios.get(`/knowledge-base/post/${slug}`);
        } catch(e) {
            return Promise.reject(e)
        }
    }

    /**
     * @description Get tickets list
     * @returns 
     */
    async getTickets() {
        try {
            return await Vue.axios.get("/support/ticket");
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description Get list data for create ticket
     * @returns Promise
     */
    async getTicketTypes() {
        try {
            return await Vue.axios.get("/support/create-ticket");
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description To save data ticket
     * @param {Object} data 
     * @returns 
     */
    async storeTicket(data = {}) {
        try {
            return await Vue.axios.post("/support/store-ticket", data, {
                headers:{
                    "Content-Type": "multipart/form-data",
                }
            })
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description Only get privacy policy in hyperlead, it not require user login to view it
     * @returns
     */
    async getPrivacyPolicySignup() {
        try {
            return await Vue.axios.get("/sign-up/privacy-policy");
        } catch(e) {
            return Promise.reject(e);
        }
    }
}

const supportService = new SupportService();

export default supportService;



// WEBPACK FOOTER //
// ./src/core/services/supportService.js